import { clsx } from 'clsx';
import { EntityAction, EntityActionConfirmDialogProps } from './interfaces/entity-actions';
import { EntityInlineActions } from './components/EntityInlineActions/EntityInlineActions';
import { EntityMenuActions } from './components/EntityMenuActions/EntityMenuActions';
import { useEntityActions } from './hooks/useEntityActions';

export interface EntityActionsProps<A extends string | number | symbol, E> {
  actions: Array<EntityAction<A>>;
  entity: E;
  updateEntityOnSuccess?: (entity: E) => void;
  getEntityFromActionResponse?: (res: unknown) => E;
  confirmationDialogProps?: EntityActionConfirmDialogProps<A, E>;
  menuLabel?: string;
  menuIconSize?: number;
}

export function EntityActions<A extends string | number | symbol, E>({
  actions,
  getEntityFromActionResponse,
  updateEntityOnSuccess,
  entity,
  confirmationDialogProps,
  menuLabel,
  menuIconSize
}: EntityActionsProps<A, E>) {
  const { inlineActions, menuActions, onActionClick } = useEntityActions<A, E>({
    actions,
    getEntityFromActionResponse,
    updateEntityOnSuccess,
    entity,
    confirmationDialogProps
  });

  if (inlineActions.length === 0 && menuActions.length === 0) {
    return null;
  }

  return (
    <div className='center-flex-row'>
      <EntityInlineActions actions={inlineActions} onActionClick={onActionClick} />

      <EntityMenuActions
        actions={menuActions}
        onActionClick={onActionClick}
        className={clsx(inlineActions.length > 0 && 'ml-3')}
        menuLabel={menuLabel}
        menuIconSize={menuIconSize}
      />
    </div>
  );
}
